import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Configuration from "../../config";
import { isLocalhost } from "../../helpers/helpers";
import { fetchSuccess, fetchUser } from "../../reducers/auth";
import "./OauthAuthentication.scss";

const storage = window.localStorage;
const OauthAuthentication = () => {
  const oAuthRedirectUri = isLocalhost
    ? `https://localhost:3000/${Configuration.get(
        "REACT_APP_OAUTH_REDIRECT_URI"
      )}`
    : `${Configuration.get("REACT_APP_GCAP_PUBLIC_HOST")}/${Configuration.get(
        "REACT_APP_OAUTH_REDIRECT_URI"
      )}`;
  const history = useHistory();
  const dispatch = useDispatch();
  const config = {
    AWS_COGNITO_CLIENT_ID: Configuration.get("REACT_APP_OAUTH_CLIENT_ID"),
    AWS_COGNITO_IDP_SIGNIN_URL: oAuthRedirectUri,
    AWS_COGNITO_CLIENT_DOMAIN_NAME: Configuration.get("REACT_APP_OAUTH_URL"),
  };
  const decodePayload = (jwtToken) => {
    const payload = jwtToken.split(".")[1];
    try {
      return JSON.parse(Buffer.from(payload, "base64").toString("utf8"));
    } catch (err) {
      return {};
    }
  };
  const calculateClockDrift = (iatAccessToken, iatIdToken) => {
    const now = Math.floor(new Date() / 1000);
    const iat = Math.min(iatAccessToken, iatIdToken);
    return now - iat;
  };
  useEffect(() => {
    const validateUserSession = () => {
      const code = new URLSearchParams(history.location.search).get("code");
      const details = {
        grant_type: "authorization_code",
        code,
        client_id: config.AWS_COGNITO_CLIENT_ID,
        redirect_uri: config.AWS_COGNITO_IDP_SIGNIN_URL,
      };
      const formBody = Object.keys(details)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(details[key])}`
        )
        .join("&");

      /* eslint-disable no-undef */
      fetch(
        "https://" + config.AWS_COGNITO_CLIENT_DOMAIN_NAME + "/oauth2/token",
        {
          /* eslint-enable no-undef */
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          body: formBody,
        }
      )
        .then((res) => {
          res
            .json()
            .then((data) => {
              const idTokenData = decodePayload(data["id_token"]);
              const accessTokenData = decodePayload(data["access_token"]);
              storage.setItem(
                "CognitoIdentityServiceProvider." +
                  config.AWS_COGNITO_CLIENT_ID +
                  ".LastAuthUser",
                idTokenData["cognito:username"]
              );
              storage.setItem(
                "CognitoIdentityServiceProvider." +
                  config.AWS_COGNITO_CLIENT_ID +
                  "." +
                  idTokenData["cognito:username"] +
                  ".idToken",
                data["id_token"]
              );
              storage.setItem(
                "CognitoIdentityServiceProvider." +
                  config.AWS_COGNITO_CLIENT_ID +
                  "." +
                  idTokenData["cognito:username"] +
                  ".accessToken",
                data["access_token"]
              );
              storage.setItem(
                "CognitoIdentityServiceProvider." +
                  config.AWS_COGNITO_CLIENT_ID +
                  "." +
                  idTokenData["cognito:username"] +
                  ".refreshToken",
                data["refresh_token"]
              );
              storage.setItem(
                "CognitoIdentityServiceProvider." +
                  config.AWS_COGNITO_CLIENT_ID +
                  "." +
                  idTokenData["cognito:username"] +
                  ".clockDrift",
                "" +
                  calculateClockDrift(
                    accessTokenData["iat"],
                    idTokenData["iat"]
                  ) +
                  ""
              );

              const username = idTokenData["cognito:username"];
              const fiscalNumber = idTokenData["custom:fiscalNumber"];
              const pec = idTokenData["custom:digitalAddress"];
              const businessName = idTokenData["custom:companyName"];
              const ivaCode = idTokenData["custom:ivaCode"];
              const {
                role = null,
                email = null,
                family_name: surname = null,
                name = null,
              } = idTokenData;

              if (role === "PROSPECT") {
                console.log(
                  "---> inside validateUserSession",
                  "fetching user for prospect"
                );
                const user = {
                  username,
                  name,
                  surname,
                  email,
                  role,
                  fiscalNumber,
                  pec,
                  businessName,
                  ivaCode,
                };
                dispatch(fetchSuccess(user));
                history.push("/spid-register");
              } else {
                dispatch(fetchUser()).then(() => {
                  history.push("/dashboard");
                });
              }
            })
            .catch((err2) => {
              const errorMessage =
                "user session invalid. auth required: " + err2;
              console.log(errorMessage);
              history.push("/login");
            });
        })
        .catch((err) => {
          const errorMessage = JSON.stringify(err);
          console.error(
            "Redirect.validateUserSession():Auth.userSession() err:",
            err,
            errorMessage
          );
          history.push("/login");
        });
    };

    validateUserSession();
    // eslint-disable-next-line
  }, []);

  return <div style={{ height: "500px" }}>loading</div>;
};

OauthAuthentication.propTypes = {};

export default OauthAuthentication;
